<template>
  <section class="courses-showcase">
    <div class="container">
      <div class="courses-showcase__header wow bounceInUp" data-wow-delay="0.1s">
        <!-- <span class="courses-showcase__eyebrow">{{ $t("ourCourses") }}</span> -->
        <h2 class="courses-showcase__title">{{ $t("courseSectionTitle") }}</h2>
        <p class="courses-showcase__description">
          {{ $t("courseSectionDescription") }}
        </p>
      </div>

      <div class="row g-4">
        <div
          v-for="(course, index) in courseCards"
          :key="course.title"
          class="col-xl-3 col-md-6 wow bounceInUp"
          :data-wow-delay="`${0.1 + index * 0.2}s`"
        >
          <div class="course-card">
            <div class="course-card__icon">
              <i :class="course.icon"></i>
            </div>

            <h3 class="course-card__title">{{ course.title }}</h3>
            <p class="course-card__text">{{ course.description }}</p>

            <router-link :to="course.link" class="course-card__link">
              {{ $t("learnMore") }}
              <i class="fas fa-arrow-right"></i>
            </router-link>

            <span class="course-card__watermark" aria-hidden="true">
              {{ course.watermark }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    courseCards() {
      return [
        {
          title: this.$t("courseBeginnerTitle"),
          description: this.$t("courseBeginnerDescription"),
          link: "/beginner-course",
          icon: "fas fa-book",
          watermark: "初",
        },
        {
          title: this.$t("courseElementaryTitle"),
          description: this.$t("courseElementaryDescription"),
          link: "/elementary-course",
          icon: "fas fa-language",
          watermark: "中",
        },
        {
          title: this.$t("courseIntermediateTitle"),
          description: this.$t("courseIntermediateDescription"),
          link: "/intermediate-course",
          icon: "fas fa-certificate",
          watermark: "上",
        },
        {
          title: this.$t("courseAdvancedTitle"),
          description: this.$t("courseAdvancedDescription"),
          link: "/upper-intermediate-course",
          icon: "fas fa-map-marked-alt",
          watermark: "極",
        },
      ];
    },
  },
};
</script>

<style scoped>
.courses-showcase {
  padding: 110px 0 88px;
  background: #ffffff;
}

.courses-showcase__header {
  max-width: 760px;
  margin-bottom: 48px;
}

.courses-showcase__eyebrow {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  margin-bottom: 18px;
  border-radius: 999px;
  background: #f3ecfb;
  color: #4a136c;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.courses-showcase__title {
  margin-bottom: 18px;
  font-size: clamp(2rem, 4vw, 3.6rem);
  font-weight: 800;
  line-height: 1.08;
  color: #2f114a;
}

.courses-showcase__description {
  max-width: 720px;
  margin: 0;
  font-size: 1.12rem;
  line-height: 1.7;
  color: #5b6170;
}

.course-card {
  position: relative;
  height: 100%;
  min-height: 410px;
  padding: 38px 32px 34px;
  border: 1px solid #eef1f5;
  border-radius: 28px;
  background: linear-gradient(180deg, #fcfcfd 0%, #f7f8fa 100%);
  overflow: hidden;
  box-shadow: 0 18px 38px rgba(23, 32, 56, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.course-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 48px rgba(23, 32, 56, 0.12);
}

.course-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin-bottom: 30px;
  border-radius: 18px;
  background: #a7e8ff;
  color: #2b6f81;
  font-size: 1.7rem;
}

.course-card__title {
  position: relative;
  z-index: 1;
  margin-bottom: 16px;
  font-size: 1.9rem;
  font-weight: 800;
  line-height: 1.2;
  color: #351153;
}

.course-card__text {
  position: relative;
  z-index: 1;
  min-height: 124px;
  margin-bottom: 34px;
  font-size: 1rem;
  line-height: 1.65;
  color: #5e6573;
}

.course-card__link {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 1.05rem;
  font-weight: 700;
  color: #2b6f81;
}

.course-card__link:hover {
  color: #235d6d;
}

.course-card__watermark {
  position: absolute;
  right: 16px;
  bottom: -10px;
  font-size: 9rem;
  line-height: 1;
  font-weight: 800;
  color: rgba(184, 196, 208, 0.18);
  pointer-events: none;
}

@media (max-width: 991px) {
  .courses-showcase {
    padding: 80px 0 68px;
  }

  .course-card {
    min-height: 360px;
  }

  .course-card__title {
    font-size: 1.7rem;
  }
}

@media (max-width: 576px) {
  .courses-showcase {
    padding: 64px 0 54px;
  }

  .courses-showcase__header {
    margin-bottom: 32px;
  }

  .courses-showcase__description {
    font-size: 1rem;
  }

  .course-card {
    min-height: auto;
    padding: 28px 24px;
  }

  .course-card__text {
    min-height: auto;
  }

  .course-card__watermark {
    font-size: 7rem;
  }
}
</style>
